import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FullSizeLoadingService {
	private loadingSubject = new BehaviorSubject<boolean>(false);
	private readonly DEFAULT_MESSAGE = 'Cargando...';

	private messageSubject = new BehaviorSubject<string>(this.DEFAULT_MESSAGE);

	loading$ = this.loadingSubject.asObservable();
	message$ = this.messageSubject.asObservable();

	constructor() {}

	open(message: string) {
		this.loadingSubject.next(true);
		this.messageSubject.next(message);
	}

	close() {
		this.loadingSubject.next(false);
		this.messageSubject.next(this.DEFAULT_MESSAGE);
	}
}
